"use client";
import React, { useCallback, useRef, useState } from "react";
import InputText from "./InputText";
import Search from "@/components/Svg/Search";
import { Add } from "iconsax-react";
import { useForm } from "react-hook-form";
import { useRouter } from "next/navigation";
import { useMutation } from "@tanstack/react-query";
import { getSearchProducts } from "@/services/productService";
import Link from "next/link";
import Image from "next/image";
import Spinner from "./Spinner,";
import { ProductType } from "@/types/productType";
import Button from "./Button";

function SearchProduct() {
  const [searchTerm, setSearchTerm] = useState("");
  const route = useRouter();
  const { register, reset, clearErrors } = useForm({ mode: "onChange" });
  const [searchValue, setSearchValue] = useState("");
  const [productList, setProuductList] = useState<ProductType[]>([]);
  const { mutateAsync: searchProductList, isPending } = useMutation({
    mutationKey: ["search"],
    mutationFn: getSearchProducts,
  });
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  // useEffect(() => {
  //   if (!searchTerm.trim()) {
  //     setProuductList([]);
  //     return;
  //   }

  //   const delayDebounceFn = setTimeout(async () => {
  //     const response = await searchProductList({ text: searchTerm });
  //     if (response?.success) {
  //       setProuductList(response.products);
  //     }
  //   }, 5000);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [searchTerm, searchProductList]);

  const handleSearchChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSearchTerm(value);
      setSearchValue(value);
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(async () => {
        if (value.trim()) {
          const response = await searchProductList({ text: value, take: 11 });
          if (response?.success) {
            setProuductList(response.products);
          }
        } else {
          setProuductList([]);
        }
      }, 1000);
    },
    [searchProductList]
  );

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && searchTerm.trim()) {
      route.push(`/search?q=${encodeURIComponent(searchTerm)}`);
      setSearchValue("");
      setSearchTerm("");
      reset();
      clearErrors();
    }
  };

  const handleSearchClick = () => {
    if (searchTerm.trim()) {
      route.push(`/search?q=${encodeURIComponent(searchTerm)}`);
      setSearchValue("");
      setSearchTerm("");
      reset();
      clearErrors();
    }
  };
  const isLoading = isPending;
  return (
    <div className="search-product-container relative hidden sm:flex">
      <Add
        size={40}
        strokeWidth={1}
        stroke="1"
        color="#686868"
        className="rotate-45 close-search"
      />
      <InputText
        type="search"
        placeholder="جستجو"
        className={`h-10  search-input  input-search `}
        containerClass="w-68 max-[680px]:w-56 border border-transparent text-xs input-search-container placeholder:text-xs z-[200]"
        badge={
          <span onClick={handleSearchClick} className="cursor-pointer">
            <Search className="w-6 h-6 top-5 search-icon" />
          </span>
        }
        badgeTextClass="pr-0 top-[7.5px] border-r-0"
        formObject={register("mobileNumber")}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        value={searchTerm}
      />
      <div
        className={` border px-3 py-2  searchbar-result-container overflow-y-auto overflow-x-hidden no-scroll  rounded-b-xl rounded-t-lg  transition-all duration-300 z-20  absolute top-10 left-0 right-0 ${
          searchValue.length > 0
            ? "h-80 border-ws-grayBlue-200 bg-white top-8"
            : "h-0 border-transparent hidden w-full"
        }     
        `}
      >
        {isLoading ? (
          <div className="h-full flex flex-col mt-4 items-center gap-5">
            <Spinner />
            <span>در حال بارگذاری...</span>
          </div>
        ) : searchValue?.length > 0 ? (
          productList?.length > 0 ? (
            productList?.length > 10 ? (
              <>
                {productList?.slice(0, 10).map((product, index) => (
                  <Link
                    href={`/product/productId=${product?.productId}&&variantid=${product?.variantId}`}
                    key={index + 1}
                    onClick={() => {
                      setSearchValue("");
                      setSearchTerm("");
                    }}
                    className="flex items-center py-4 border-b last:border-b-0"
                  >
                    <div className="w-2/5 flex justify-center items-center">
                      <Image
                        priority
                        fetchPriority="high"
                        sizes="100vw"
                        width={80}
                        height={80}
                        alt={product.productName}
                        src={product.image}
                        unoptimized
                      />
                    </div>
                    <div className="w-3/5 flex items-start justify-between flex-col">
                      <p className="w-full text-right text-sm mb-1">
                        {product.productName}
                      </p>
                      <span className="num-vazir">
                        {product?.salePrice?.toLocaleString()}
                      </span>
                    </div>
                  </Link>
                ))}
                <Link
                  href={`/search?q=${searchValue}`}
                  onClick={() => {
                    setSearchValue("");
                    setSearchTerm("");
                  }}
                  className="flex justify-center items-center"
                >
                  <Button
                    variant="dark-gray"
                    className="my-4 py-2 px-8 rounded-lg"
                  >
                    بیشتر
                  </Button>
                </Link>
              </>
            ) : (
              productList?.map((product, index) => (
                <Link
                  href={`/product/productId=${product?.productId}&&variantid=${product?.variantId}`}
                  key={index + 1}
                  onClick={() => {
                    setSearchValue("");
                    setSearchTerm("");
                  }}
                  className="flex items-center py-4 border-b last:border-b-0"
                >
                  <div className="w-2/5 flex justify-center items-center">
                    <Image
                      width={80}
                      height={80}
                      alt={product.productName}
                      src={product.image}
                      unoptimized
                    />
                  </div>
                  <div className="w-3/5 flex items-start justify-between flex-col">
                    <p className="w-full text-right text-sm mb-1">
                      {product.productName}
                    </p>
                    <span className="num-vazir">
                      {product?.salePrice?.toLocaleString()}
                    </span>
                  </div>
                </Link>
              ))
            )
          ) : (
            <div className="flex flex-col justify-center items-center gap-3 mt-14">
              <p className="text-center">
                <Image
                  priority
                  fetchPriority="high"
                  sizes="100vw"
                  className="w-32 h-32"
                  src="/images/empty-search.png"
                  width={10000}
                  height={2000}
                  alt="empty-search"
                  unoptimized
                />
                نتیجه ای یافت نشد
              </p>
            </div>
          )
        ) : null}
      </div>
    </div>
  );
}

export default SearchProduct;
